export { MultiSelect, type MultiSelectProps } from "@mantine/core";
export { multiSelectOverrides } from "./MultiSelect.config";
